<template>
  <div class="privacy">
    <el-dialog :visible.sync="privacy" title="隐私政策">
      <p v-html="content"></p>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="handleConfirm">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
  export default {
    data () {
      return {
        privacy: false,
        content: '',
      };
    },
    methods: {
      handleShow () {
        this.$axios.get('/hq-agency/agreement/get/2').then((res) => {
          if (res.code === 200) {
            this.content = res.data;
            this.privacy = true;
          } else {
            this.$message.error("网络异常，请稍后再试");
          }
        });
      },
      handleConfirm () {
        this.privacy = false;
      }
    }
  };
</script>
<style lang="less">
  .privacy {
    .el-dialog {
      max-height: 500px;
      .el-dialog__body {
        overflow-y: scroll;
      }
    }
    .el-dialog__body {
      overflow: hidden;
      font-size: 12px;
      color: #333333;
      max-height: 328px;
      .title {
        font-weight: bolder;
        padding: 20px 0;
      }
      .content {
        text-indent: 2em;
        p {
          padding-bottom: 15px;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// Privacy.vue?5fd3ef9a